<template lang="pug">
v-container
  //- Popup Create Pet
  v-dialog(v-model="show_create_pet", max-width="600")
    CreateUpdatePet(:vets='vets', :owners='owners', :species='species')
  //- Popup view pet
  v-dialog(v-model="show_pet", max-width="500")
    ViewPet(:show_pet="show_pet", :pet="pet_selected", :detail="true")
  //- Header
  v-row(align="center", justify="space-between")
    v-col(cols="12", sm="2")
      h2.secondary--text Mis Mascotas
    v-col(v-if="user.role.slug != 'owner'", cols="12", sm="2")
      v-btn(outlined, color="secondary", @click="createPet", :loading="loadingBtn") Añadir Mascota
  //- List Pets
  Table(
    @edit="editPet",
    @view="viewPet",
    @delete="erasePet",
    :loading="loading",
    :headers="headers",
    @search="searchPet",
    :searchServer="true",
    :items="pets.results",
    @getPage="getPetPage",
    :additionalsAccions="true",
    :pageCount="pets.links.last_page",
    :itemsPerPage="pets.links.per_page",
    @downloadCarnet="downloadCarnetPet",
    :enableDelete="user.role.slug != 'owner'",
    @downloadVaccineCard="downloadVaccineCardPet"
  )
</template>

<script>
import petAPI from "@/api/pet";
import utils from "@/resources/utils";
import { mapState, mapGetters } from "vuex";
import Table from "@/components/Table.vue";
import ViewPet from "@/components/pets/ViewPet.vue";
import CreateUpdatePet from "@/components/pets/CreateUpdatePet.vue";

export default {
  name: "Pets",
  components: {
    ViewPet,
    Table,
    CreateUpdatePet
  },
  async created() {
    if (!this.auth_token) {
      this.$router.push("/auth/login");
    }
    this.getPetPage(1);
    this.loadingBtn = true;
    await this.$store.dispatch("users/getUserWithoutPagination", {
      vet: true,
      owner: false,
      token: this.auth_token
    });
    await this.$store.dispatch("users/getUserWithoutPagination", {
      vet: false,
      owner: true,
      token: this.auth_token
    });
    await this.$store.dispatch("inventories/getInventoriesWithoutPagination", {
      assign: false,
      no_assign: false,
      token: this.auth_token
    });
    await this.$store.dispatch(
      "species/getSpeciesWithoutPagination",
      this.auth_token
    );
    this.loadingBtn = false;
  },
  computed: {
    ...mapState({
      pets: state => state.pets.pets,
      user: state => state.auth.user,
      auth_token: state => state.auth.auth_token,
      vets: state => state.users.vets_without_pagination,
      owners: state => state.users.owners_without_pagination,
      species: state => state.species.speciesWithoutPagination
    }),
    ...mapGetters({
      choices: "selectChoices"
    })
  },
  data() {
    return {
      loading: false,
      loadingBtn: true,
      headers: [
        { text: "Nombre", value: "name" },
        { text: "Color", value: "color" },
        { text: "Raza", value: "race" },
        { text: "Especie", value: "specie" },
        { text: "Genero", value: "gender" },
        { text: "Actiones", value: "actions" }
      ],
      pet_selected: {},
      show_pet: false,
      show_create_pet: false,
      messages_error_or_empty: "No tienes mascotas registradas"
    };
  },
  methods: {
    editPet(pet) {
      this.$router.push(`/pets/${pet.id}`);
    },
    viewPet(pet) {
      this.show_pet = true;
      this.pet_selected = pet;
    },
    createPet() {
      this.show_create_pet = true;
    },
    async getPetPage(page, search) {
      this.loading = true;
      await this.$store.dispatch("pets/getPets", {
        token: this.auth_token,
        page: page,
        search: search ?? null
      });
      this.loading = false;
    },
    async erasePet(pet) {
      this.$swal({
        title: `¿Estas seguro de borrar la información de ${pet.name}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No"
      }).then(async result => {
        if (result.value) {
          const response = await petAPI.deletePet(pet.id, this.auth_token);

          if (response.status) {
            this.$swal({
              title: `Información de Mascota Borrada`,
              icon: "success"
            });
            await this.$store.dispatch("pets/getPetsWithoutPag", {
              token: this.auth_token,
              page: 1
            });
          } else {
            this.$swal({
              title: response.data,
              icon: "error"
            });
          }
        }
      });
    },
    async downloadCarnetPet(pet) {
      const response = await petAPI.generateCarnetPDF(pet.id, this.auth_token);
      if (response.status) {
        utils.downloadFiles(response.data, "Carnet_Mascota.pdf");
      }
    },
    async downloadVaccineCardPet(pet) {
      const response = await petAPI.generateHistoryPDF(pet.id, this.auth_token);
      if (response.status) {
        utils.downloadFiles(response.data, "Carnet_Vacunación_Mascota.pdf");
      }
    },
    async searchPet(search) {
      await this.getPetPage(1, search);
    }
  }
};
</script>
